import { combineReducers, configureStore } from "@reduxjs/toolkit";
import jsonReducer from "./slices/jsonSlice";
import codeReducer from "./slices/codeSlice";
import chatReducer from "./slices/chatSlice";
import { useDispatch, useSelector } from "react-redux";
import { debounce } from "lodash";
import { JsonBuilderServiceModel } from "../Site/services/JsonBuilderService";
import BuilderService from "../Site/services/BuilderService";
import { updateAppChangedStatus, changeSavingStatus } from "./slices/jsonSlice";
import userSlice from "./slices/userSlice";
import agentSlice from "./slices/agentSlice";
import commonEmitterSlice from "./slices/commonEmitterSlice";
import themeSlice from "./slices/themeSlice";
import loadingSlice from "./slices/loadingSlice";
const builderServiceInstance = new BuilderService();
const debouncedUpdateApp = debounce(
  async (id: string, data: JsonBuilderServiceModel, store) => {
    try {
      await builderServiceInstance.updateApp(id, data);
      // Once the data is saved to the backend, we need to set changed to true.
      if (data.isLive) {
        store.dispatch(updateAppChangedStatus(true));
      }
    } catch (error) {
    } finally {
      store.dispatch(changeSavingStatus(false));
    }
  },
  800
);

const saveAppMiddleware =
  (store: any) => (next: any) => async (action: any) => {
    const result = next(action);
    if (action.type === "jsonObject/updateAndSaveProperty") {
      const state = store.getState().jsonObject.data;
      debouncedUpdateApp(state._id, state, store);
    }
    return result;
  };

const rootReducer = combineReducers({
  jsonObject: jsonReducer,
  codeObject: codeReducer,
  chat: chatReducer,
  userObject: userSlice,
  agentObject: agentSlice,
  commonEmitterObject: commonEmitterSlice,
  themeObject: themeSlice,
  loadingObject: loadingSlice,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(
      saveAppMiddleware
    ),
});

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
